var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaGlow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Glow",
    cx: 210,
    cy: 210,
    r: 210,
    fill: "url(#paint0_radial_0_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_34",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210 210) scale(210)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2663EB",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663EB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaGlow1);
export default __webpack_public_path__ + "static/media/cta-glow-1.339cb0b1621dbee0b0eb42654653b290.svg";
export { ForwardRef as ReactComponent };